import { TooltipProps } from "recharts";
import { ValueType, NameType } from "recharts/types/component/DefaultTooltipContent";
import React from "react";

const CustomTooltip = ({
  active,
  payload,
  label,
}: TooltipProps<ValueType, NameType>) => {
  if (active && payload && payload.length > 0) {
    return (
      <div className="bg-white border p-2 rounded shadow text-xs">
        <p className="font-semibold">{label}</p>
        {payload.map((entry, index) => (
          <p key={index} style={{ color: entry.color }}>
            Total Mensalidade: R$ {Number(entry.value).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
          </p>
        ))}
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
